<template>
  <head-com class="header"></head-com>
  <router-view></router-view>
  <foot-com></foot-com>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted } from 'vue';
import HeadCom from './components/HeadCom.vue';
import FootCom from './components/FootCom.vue';
import { userSignalR } from './bgdata/index';
import { userSignalRStore } from './stores/scene';
import { jwtDecode } from "jwt-decode"
const { startConnection, stopConnection, onRegistered, onReceiveMessage,RegistUserConnection } = userSignalR();


export default defineComponent({
  name: 'App',
  components: {
    HeadCom,
    FootCom
  },
  setup() {
    const signalRstore = userSignalRStore();

    onMounted(() => {
      startConnection();
      onRegistered((connectionId: string) => {
        signalRstore.setConnectionId(connectionId);
        if (localStorage.getItem("jwtToken")) {
          let jwttoken = localStorage.getItem('jwtToken')??'';
          let docde = jwtDecode(jwttoken) as {['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier']:string};
          const userguid=docde['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'];
          RegistUserConnection(userguid,connectionId);
        }


      });
      onReceiveMessage((message: any) => {
        console.log('Received message from server:', message);
        signalRstore.setSignalRMessage(message);
      });
    });
    onUnmounted(() => {
      // 清理工作
      stopConnection();
    });
  }
});
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-top: 60px;
}

@media screen and (max-width: 768px) {
  #app {
    padding-top: 48px;
  }

}

.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}
</style>
